export default __webpack_public_path__ + "static/media/RecipeIndex.a92625e8.jpg";